export const getScheduleRecharge = scheduleId => {
  return {
    type: 'GET_SCHEDULE_RECHARGE',
    payload: {
      client: 'cloudloyalty',
      request: {
        method: 'get',
        url: `/v1/myschedules/${scheduleId}`
      }
    }
  }
}

export default {
  getScheduleRecharge
}



// WEBPACK FOOTER //
// ./src/features/ConfirmationMobileRechargeSchedule/actions.js